import validator from "validator";

export const validateField = (setFunction, field, value, idx) => {
  let error = {
    hasError: false,
    message: "",
  };
  if (value === "" || null) {
    error = {
      hasError: true,
      message: "This field is required.",
    };
  } else {
    switch (field) {
      case "phone":
        if (!validator.isMobilePhone(value, "any")) {
          error = {
            hasError: true,
            message: `A valid phone number is required.`,
          };
        }
        break;

      default:
        break;
    }
  }
  setFunction((prevVal) => {
    const newDocs = [...prevVal];
    newDocs[idx][field] = error;
    return newDocs;
  });
};

export const validateFieldsPhones = (phones, phonesError, setFunction) => {
  let hasError = false;
  phones.forEach((clientPhone, idx) => {
    for (const field in clientPhone) {
      if (clientPhone[field] === "" || clientPhone[field] === null) {
        hasError = true;
        setFunction((prevVal) => {
          const newDocs = [...prevVal];
          newDocs[idx][field] = {
            hasError: true,
            message: "This field is requiered.",
          };
          return newDocs;
        });
      }
    }

    for (const field in phonesError[idx]) {
      if (phonesError[idx][field].hasError) hasError = true;
    }
  });

  return hasError;
};
